import { render, staticRenderFns } from "./LabelResume.vue?vue&type=template&id=406a13cb&scoped=true"
import script from "./LabelResume.vue?vue&type=script&lang=js"
export * from "./LabelResume.vue?vue&type=script&lang=js"
import style0 from "./LabelResume.vue?vue&type=style&index=0&id=406a13cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a13cb",
  null
  
)

export default component.exports